const names = {
  "admin.aniyadak.ir" : {
    store_faName: "آنی یدک",
    store_enName: "aniyadak",
    phoneNumber: "02136055193",
    email:"aniyadak.ir@gmail.com"
  }
}

export const globalState = names[window.location.hostname] || {
  store_faName: "ویتسل",
  store_enName: "vitsell",
  phoneNumber: "02123456789",
  email:"vistaapp.ir@gmail.com"
};



